<template>
    <div class="meetings">
        <Navigation/>
        <v-main>
            <v-container>
                <v-row v-if="$acl.not.check('isUserPremium') && $acl.not.check('isProPremium')">
                    <v-col cols="12">
                        <NotPremiumCard/>
                    </v-col>
                </v-row>

                <v-row v-else>
                    <v-col cols="12">
                        <v-card elevation="4" :color="isAja ? '#4E983C' : 'primary'">
                            <v-card-text>
                                <v-row no-gutters align="center" class="headline mb-3">
                                    <v-col cols="auto"><v-icon x-large class="white--text mr-5">alarm</v-icon></v-col>
                                    <v-col class="font-weight-bold white--text text-no-wrap">
                                        <template v-if="user">
                                            Liste des séances de {{ user.complete_name }}
                                        </template>
                                        <template v-else-if="isMeetingsProMode">
                                            Mes séances PRO
                                        </template>
                                        <template v-else>
                                            Liste de mes séances
                                        </template>
                                    </v-col>
                                </v-row>

                                <v-row dense align="center">
                                    <v-col v-if="user" cols="12" :sm="6" :md="3">
                                        <v-autocomplete
                                            v-model="search.partner_id"
                                            :items="allPartner"
                                            item-text="name"
                                            item-value="id"
                                            label="Partenaire"
                                            :loading="partnersLoading"
                                            flat
                                            solo
                                            clearable
                                            hide-details
                                            no-data-text="Aucun partenaire trouvé"
                                            :class="{'aja-input': isAja}"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" :sm="6" :md="3">
                                        <v-select
                                            v-model="search.dates"
                                            :items="allDates"
                                            label="Séances"
                                            flat
                                            solo
                                            clearable
                                            hide-details
                                            :class="{'aja-input': isAja}"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" :sm="6" :md="3">
                                        <v-select
                                            v-model="search.type"
                                            :items="types"
                                            label="Type de séance"
                                            flat
                                            solo
                                            clearable
                                            hide-details
                                            :class="{'aja-input': isAja}"
                                        ></v-select>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="12" md="auto">
                                        <v-row no-gutters align="center">
                                            <v-col>
                                                <v-select
                                                    v-model="options.sortBy"
                                                    clearable
                                                    flat
                                                    solo
                                                    hide-details
                                                    prepend-inner-icon="swap_vert"
                                                    label="Trier par"
                                                    :items="sortables"
                                                    :class="{'aja-input': isAja}"
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-btn-toggle
                                                    v-model="options.sortDesc"
                                                    group
                                                    color="black"
                                                >
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn :value="false" v-on="on">
                                                                <v-icon :class="{'aja-text-white': isAja}">keyboard_arrow_up</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Croissant</span>
                                                    </v-tooltip>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn :value="true" v-on="on">
                                                                <v-icon :class="{'aja-text-white': isAja}">keyboard_arrow_down</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Décroissant</span>
                                                    </v-tooltip>
                                                </v-btn-toggle>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12">
                        <v-card elevation="0" :color="isAja ? '#4E983C' : 'primary'">
                            <v-card-text class="body-1 font-weight-bold" :style="{color: isAja ? 'white': ''}">
                                Le n° de la séquence n’a pas d’importance, vous pouvez commencer n’importe quand.
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col v-if="!user_id && $acl.check('isUserPremium')" cols="12">
                        <MeetingsRecap />
                    </v-col>

                    <v-col cols="12">
                        <v-data-table 
                            :style=" isAja ? {backgroundColor:'#1E3945'} : {}" 
                            :items="meetings || []"
                            :headers="[
                                {
                                    text: 'Atelier',
                                    align: 'left',
                                    value: 'workshop.name',
                                    sortable: false,
                                },
                                {
                                    text: 'Date',
                                    align: 'center',
                                    value: 'start',
                                    sortable: false,
                                },
                                {
                                    text: 'Type',
                                    align: 'center',
                                    value: 'type',
                                    sortable: false,
                                },
                                {
                                    text: 'Places',
                                    align: 'center',
                                    value: 'places_diff',
                                    sortable: false,
                                },
                                {
                                    text: 'Séquence',
                                    value: 'sequence', 
                                    align: 'center', 
                                    sortable: false,
                                },
                                {
                                    text: 'Supports',
                                    value: 'downloads',
                                    align: 'center',
                                    sortable: false,
                                },
                                {
                                    text: 'État',
                                    value: 'actions',
                                    align: 'center',
                                    sortable: false,
                                },
                            ]"
                            :options.sync="options"
                            :server-items-length="total"
                            :loading="loading"
                            hide-default-footer  
                            :item-class="(item) => {return {'grey--text': $moment().diff(item.start) > 0}}"
                        >
                            <template v-slot:item.workshop.name="{ item }">
                                <router-link :style="{ color: isAja ? ($vuetify.theme.dark ? 'white' : '#1E3945') : 'primary' }" :to="{name: 'Workshop', params: {id: item.workshop.id}}">
                                   <v-icon color="primary" v-if="item.workshop.workshop_type == 'oncommence'">waving_hand</v-icon>
                                   <span>{{ item.workshop.name }}</span>
                                </router-link>
                            </template>

                            <template v-slot:item.start="{ item }">
                                <div class="text-center">
                                    <div class="text-no-wrap">{{ $moment(item.start).format('dddd DD/MM/YYYY') }}</div>
                                    <div class="text-no-wrap text-caption" :class="{'grey--text': $moment().diff(item.start) > 0}">{{ $moment(item.start).format('HH[h]mm') }} - {{ $moment(item.end).format('HH[h]mm') }}</div>
                                </div>
                            </template>

                            <template v-slot:item.type="{ item }">
                                <v-btn dark :color=" isAja ? '#294D5B' : ''" v-if="item.type == 'remote'"  class="px-11" style="border-radius: 0px; pointer-events: none;">
                                    VISIO
                                </v-btn>

                                <v-btn color="#D3D3D3" dark v-if="item.type == 'onsite'" style="color: black; border-radius: 0px; pointer-events: none;">
                                    PRESENTIEL
                                </v-btn>
                            </template>

                            <template v-slot:item.places_diff="{ item }">
                                {{ item.places - item.validated_subscribers_count }} <small>/ {{ item.places }}</small>
                            </template>

                            <template v-slot:item.downloads="{ item }">
                                <template v-if="$moment().diff($moment(item.end).add(10, 'minutes')) < 0 && !user && !isLateUnsubscription(item)">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-on="on"
                                                v-bind="attrs"
                                                outlined
                                                :color="isAja ? '#4E983C' : 'primary'"
                                                small
                                                class="mx-5"
                                                depressed
                                            >
                                                <v-icon>get_app</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="downloadSupport('user', item)">
                                                <v-list-item-title>Télécharger le livret d’activités de la séance</v-list-item-title>
                                            </v-list-item>
                                             <v-list-item v-if="item.type == 'onsite' && item.address">
                                                <v-list-item-title>Adresse : {{ item.address }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="item.type == 'remote' && item.link">
                                                <v-list-item-title v-html="urlify(item.link)"></v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <!-- Late unsubscription (illegitimate cancellation) -->
                                <template v-if="isLateUnsubscription(item)">
                                    <div class="d-flex align-center justify-center">
                                        <v-chip color="error" small>
                                            Désinscription tardive
                                        </v-chip>
                                        <v-tooltip bottom v-if="canResubscribe(item)">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    color="primary"
                                                    x-small
                                                    icon
                                                    class="ml-2"
                                                    :loading="loadingStates[item.id] && loadingStates[item.id].subscribe"
                                                    @click="subscribeMeeting(item.id)"
                                                >
                                                    <v-icon small>refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Se réinscrire</span>
                                        </v-tooltip>
                                    </div>
                                </template>
                                <!-- Active subscriptions -->
                                <template v-else-if="$moment().diff(item.end) <= 0">
                                    <v-tooltip bottom v-if="isValidatedSubscriber(item) && $moment().diff(item.start) <= 0">
                                        <template v-slot:activator="{ on }">
                                            <ConfirmButton
                                                :on="on"
                                                buttonText="Inscrit"
                                                headline="Vous êtes sur le point d'annuler votre participation à cette séance"
                                                :subtext="getUnsubscribeWarning(item)"
                                                :confirm-text="showLateUnsubscribeWarning(item) ? 'Se désinscrire quand même' : 'Confirmer'"
                                                :dialog-width="showLateUnsubscribeWarning(item) ? 650 : 500"
                                                color="green"
                                                small
                                                @confirmed="unsubscribeMeeting(item.id)"
                                                class="mx-5"
                                            />
                                        </template>
                                        <span>Cliquer pour annuler votre participation</span>
                                    </v-tooltip>
                                    <WaitlistButton
                                        v-if="isWaitingSubscriber(item)"
                                        :meeting="item"
                                        :loading="loadingStates[item.id] && loadingStates[item.id].unsubscribe"
                                        :is-left="true"
                                        button-text="Sur liste d'attente"
                                        :is-theme-aja="!!isAja"
                                        :is-dark-theme="$vuetify.theme.dark"
                                        @unsubscribe="unsubscribeMeeting"
                                        @take-place="handleTakePlace"
                                    />
                                </template>
                                <!-- Past validated sessions: attendance state (Présent / Absent / appel non fait) -->
                                <template v-else-if="isValidatedSubscriber(item)">
                                    <v-chip v-if="item.pivot.attendance" :color="isAja ? '#4E983C' : 'success'" dark small>
                                        Présent
                                    </v-chip>
                                    <v-chip v-else-if="item.pivot.attendance != null" color="error" dark small>
                                        Absent
                                    </v-chip>
                                    <span v-else class="grey--text">-</span>
                                </template>
                            </template>

                            <template v-slot:loading>
                                <v-row align="stretch">
                                    <v-col>
                                        <v-skeleton-loader type="table-tbody" height="400px" width="100%" :class="{'aja-skeleton': isAja}"></v-skeleton-loader>
                                    </v-col>
                                </v-row>
                            </template>

                            <template v-slot:no-data>
                                <v-icon x-large>sentiment_satisfied</v-icon>
                                <br>
                                <span class="title">Aucune séance trouvée</span>
                            </template>

                        </v-data-table>
                    </v-col>
                    <v-col cols="12" v-if="!loading" class="mt-5" align="center" justify="center">
                        <v-btn
                            fab
                            color="primary"
                            class="mr-1"
                            @click="prevPage"
                            :disabled="options.page <= 1"
                        >
                            <v-icon x-large>keyboard_arrow_left</v-icon>
                        </v-btn>
                        <span class="mx-4 grey--text">
                            Page {{ options.page }} sur {{ lastPage }}
                        </span>
                        <v-btn
                            fab
                            color="primary"
                            class="ml-1"
                            @click="nextPage"
                            :disabled="options.page == lastPage"
                        >
                            <v-icon x-large>keyboard_arrow_right</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </div>
</template>

<script>
import WaitlistButton from '@/components/meetings/WaitlistButton.vue'
import MeetingsRecap from '@/components/meetings/MeetingsRecap.vue'

export default {
    components: {
        WaitlistButton,
        MeetingsRecap,
    },
    props: {
        user_id: { type: [String, Number], required: false },
    },
    data () {
        return {
            ready: false,
            meetings: [],
            options: {
                page: parseInt(this.$route.query.page) || 1,
                itemsPerPage: 15,
                sortBy: this.$route.query.sortBy || 'start',
                sortDesc: this.$route.query.sortDesc ? this.$route.query.sortDesc == 'true' : true,
                groupBy: [],
                groupDesc: [],
                mustSort: false,
                multiSort: false,
            },
            search: this.$route.query.search ? JSON.parse(this.$route.query.search) : {},
            sortables: [
                {value: 'start', text: 'Date'},
                {value: 'sequence', text: 'Séquence'},
            ],
            total: 0,
            isMobile: false,
            loading: false,
            allDepartments: [],
            allCities: [],
            allPartner: [],
            types: [],
            allDates: [],
            departmentsLoading: false,
            citiesLoading: false,
            partnersLoading: false,
            user: null,
            loadingStates: {},
        }
    },
    mounted () {
        this.initAdvancedSearch()

        if (this.user_id) {
            this.fetchUser()
        }  
        
        this.refreshPagination()
    },
    computed: {
        lastPage() {
            return Math.ceil(this.total / this.options.itemsPerPage)
        },
        // https://github.com/vuejs/vue/issues/2164#issuecomment-432872718
        computedOptions: function() {
            return Object.assign({}, this.options);
        },
        isThePro() {
            // En mode 'MeetingsPro', un ADH PRO consulte ses inscriptions (vue user), pas les séances qu'il anime
            return this.$acl.check('isProPremium') && !this.isMeetingsProMode
        },
        isMeetingsProMode() {
            return this.$route.name === 'MeetingsPro'
        },
        isAja() {
            return this.$store.getters.getProfile.is_aja
        },
    },
    methods: {
        prevPage() {
            if (this.options.page - 1 >= 1) this.options.page -= 1
        },
        nextPage() {
            if (this.options.page + 1 <= this.lastPage) this.options.page += 1
        },
        refreshPagination () {
            const searchPayload = {...this.search, user_id: this.user_id || this.$store.getters.getProfile.id}
            if (this.isMeetingsProMode) {
                searchPayload.is_pro = true
            }
            const queries = {
                page: this.options.page,
                per_page: this.options.itemsPerPage,
                sort: this.options.sortBy,
                direction: this.options.sortDesc ? 'desc' : 'asc',
                search: JSON.stringify(searchPayload),
                with: ['workshop.partner'],
            }

            this.loading = this.isAja ? "#4E983C" : true
            this.meetings = []

            if (this.isThePro) {
                queries.with.push('subscribers')
                this.$store.dispatch('meetingsRequest', queries)
                .then(result => {
                    if (! result.data.length && this.options.page > 1)
                        this.options.page--

                    if (! result.data.length)
                        this.options.page = 0
                    this.total = result.meta.total
                    this.meetings = result.data
                    this.loading = false
                    this.ready = true;
                })
                .catch((err) => {
                    this.loading = false
                    if (err.response.status != 403)
                        this.$store.dispatch('setErrors', err.response.data)
                })
            } else {
                this.getUserSubscribitions(queries)
            }
        },
        initAdvancedSearch() {
            this.fetchPartner()
            // init dates items
            this.types = [
                {
                    text: 'Visio', 
                    value: 'remote'
                },
                {
                    text: 'Présentiel', 
                    value: 'onsite'
                },
            ],
            this.allDates = [
                {
                    text: 'Cette semaine', 
                    value: [
                        this.$moment().startOf('week').format('YYYY-MM-DD'), 
                        this.$moment().endOf('week').format('YYYY-MM-DD')
                    ]
                },
                {
                    text: 'La semaine prochaine', 
                    value: [
                        this.$moment().add(1, 'week').startOf('week').format('YYYY-MM-DD'),
                        this.$moment().add(1, 'week').endOf('week').format('YYYY-MM-DD'),
                    ]
                },
                {
                    text: 'Ce mois-ci', 
                    value: [
                        this.$moment().startOf('month').format('YYYY-MM-DD'),
                        this.$moment().endOf('month').format('YYYY-MM-DD'),
                    ]
                },
                {
                    text: 'Le mois prochain', 
                    value: [
                        this.$moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),
                        this.$moment().add(1, 'month').endOf('month').format('YYYY-MM-DD'),
                    ]
                },
            ]
        },
        fetchPartner(event) {
            this.partnersLoading = 'secondary'
            this.$store.dispatch('partnersRequest', {})
                .then((result) => {
                    this.allPartner = result.data
                })
                .catch((err) => {
                }).finally(() => {
                    this.partnersLoading = false
                })
        },
        fetchUser() {
            this.$store.dispatch('userRequest', {id: this.user_id})
                .then(result => {
                    this.user = result.data
                })
                .catch((err) => {
                    if (err.response.status != 403)
                        this.$store.dispatch('setErrors', err.response.data)
                })
        },
        unsubscribeMeeting(meeting_id, showNotification = true, forced = false) {
            // Initialize loading state for this meeting if it doesn't exist
            if (!this.loadingStates[meeting_id]) {
                this.$set(this.loadingStates, meeting_id, {})
            }
            // Set unsubscribe loading state for this specific meeting
            this.$set(this.loadingStates[meeting_id], 'unsubscribe', true)

            return this.$store.dispatch('meetingUnsubscribeRequest', {
                meeting_id: meeting_id,
                user_id: this.$store.getters.getProfile.id,
                forced: forced
            }).then((response) => {
                if (showNotification) {
                    if (response.status === 202) {
                        this.$store.commit('setSnack', {
                            'type': 'success',
                            'msg': "Vous n'êtes plus sur la liste d'attente de cette séance"
                        })
                    } else {
                        this.$store.commit('setSnack', {
                            'type': 'success',
                            'msg': "Votre annulation de participation à la séance est prise en compte !"
                        })
                    }
                }
                this.refreshPagination()
                return response
            }).catch((err) => {
                if (err.response.status != 403)
                    this.$store.dispatch('setErrors', err.response.data)
                throw err
            }).finally(() => {
                // Reset loading state for this specific meeting
                this.$set(this.loadingStates[meeting_id], 'unsubscribe', false)
            });
        },
        subscribeMeeting(meeting_id) {
            // Initialize loading state for this meeting if it doesn't exist
            if (!this.loadingStates[meeting_id]) {
                this.$set(this.loadingStates, meeting_id, {})
            }
            // Set subscribe loading state for this specific meeting
            this.$set(this.loadingStates[meeting_id], 'subscribe', true)

            return this.$store.dispatch('meetingSubscribeRequest', {
                meeting_id: meeting_id,
                user_id: this.$store.getters.getProfile.id
            }).then((response) => {
                if (response.status === 202) {
                    this.$store.commit('setSnack', {
                        'type': 'warning',
                        'msg': "Trop tard, la séance est déjà pleine ! Vous êtes de nouveau sur liste d'attente."
                    })
                } else {
                    this.$store.commit('setSnack', {
                        'type': 'success',
                        'msg': "Vous êtes bien inscrit à cette séance !"
                    })
                }
                this.refreshPagination()
                return response
            }).catch((err) => {
                if (err.response?.status !== 403) {
                    this.$store.dispatch('setErrors', err.response?.data)
                }
                throw err
            }).finally(() => {
                // Reset loading state for this specific meeting
                this.$set(this.loadingStates[meeting_id], 'subscribe', false)
            });
        },
        isValidatedSubscriber(meeting) {
            if (!this.meetings || this.meetings.length === 0) {
                return false;
            }
            
            const subscription = this.meetings.find(sub => sub.id === meeting.id);

            if (!subscription || !subscription.pivot) {
                return false;
            }
            
            return subscription.pivot.status === 'validated';
        },
        isWaitingSubscriber(meeting) {
            if (!this.meetings || this.meetings.length === 0) {
                return false;
            }

            const subscription = this.meetings.find(sub => sub.id === meeting.id);

            if (!subscription || !subscription.pivot) {
                return false;
            }

            return subscription.pivot.status === 'waiting';
        },
        isLateUnsubscription(meeting) {
            if (!this.meetings || this.meetings.length === 0) {
                return false;
            }

            const subscription = this.meetings.find(sub => sub.id === meeting.id);

            if (!subscription || !subscription.pivot) {
                return false;
            }

            return subscription.pivot.status === 'canceled'
                && subscription.pivot.is_legitimate_unsubscription === false;
        },
        canResubscribe(meeting) {
            // Can resubscribe if: late unsubscription + meeting is in the future + places available
            if (!this.isLateUnsubscription(meeting)) {
                return false;
            }
            const isFuture = this.$moment().diff(meeting.start) < 0;
            const hasPlaces = (meeting.places - meeting.validated_subscribers_count) > 0;
            return isFuture && hasPlaces;
        },
        downloadSupport(type, meeting) {
            let supportType = 'classique'
            if (meeting.workshop.is_aja)
                supportType = 'aja'
            
            const queries = {
                per_page: -1,
                search: JSON.stringify({'sequence': meeting.sequence, 'support_type': supportType}),
                with: ['user_attachment'],
            }
            return this.$store.dispatch('supportsRequest', queries).then((data) => {
                let results = data.data
                if (results.length)
                    this.downloadAttachment(results[0][type+'_attachment'], meeting.id)
            }).catch((err) => {
                if (err.response?.status != 403)
                    this.$store.dispatch('setErrors', "Une erreur est survenue lors de la récupération des supports. Veuillez réessayer plus tard.")
            });
        },
        downloadAttachment(attachment, meetingId = null) {
            const params = { id: attachment.id }
            if (meetingId) {
                params.meeting_id = meetingId
            }
            return this.$store.dispatch('attachmentDownloadRequest', params).then((data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', attachment.name);
                document.body.appendChild(link);
                link.click();
            });
        },
        urlify(text) {
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, (url) =>'<a href="' + url + '" target="_blank">' + url + '</a>');
        },
        isMeetingWithin36Hours(meeting) {
            const now = this.$moment();
            const meetingStart = this.$moment(meeting.start);
            const hoursUntilMeeting = meetingStart.diff(now, 'hours');
            return hoursUntilMeeting >= 0 && hoursUntilMeeting < 36;
        },
        showLateUnsubscribeWarning(meeting) {
            // No late warning for ONCO'MMENCE workshops
            if (meeting.workshop?.workshop_type === 'oncommence') {
                return false;
            }
            return this.isMeetingWithin36Hours(meeting);
        },
        getUnsubscribeWarning(meeting) {
            // No penalty warning for ONCO'MMENCE workshops
            if (meeting.workshop?.workshop_type === 'oncommence') {
                return '';
            }
            if (this.isMeetingWithin36Hours(meeting)) {
                return `<strong>Attention :</strong> Cette séance commence dans moins de 36 heures.<br><br>
                    Si vous vous désinscrivez maintenant, <strong>cette séance sera comptabilisée</strong>
                    dans votre quota de séances et comptera comme une annulation tardive.`;
            }
            return '';
        },
        getUserSubscribitions(queries) {
            this.meetings = []

            queries = {
                user_id: this.$store.getters.getProfile.id,
                ...queries,
            }

            this.$store.dispatch('getUserSubscribitionsRequest', queries)
            .then((response) => {
                this.meetings = response.data
                this.total = response.meta.total
                this.loading = false
                this.ready = true
            }).catch((err) => {
                if (err.response?.status != 403)
                    this.$store.dispatch('setErrors', err.response?.data || "Une erreur est survenue lors de la récupération des séances. Veuillez réessayer plus tard.")
                this.meetings = []
            })
        },
        async handleTakePlace(meeting) {
            try {
                // For oncommence meetings, unsubscribe from all other future oncommence subscriptions (#F_SEA_31)
                if (meeting.workshop?.workshop_type === 'oncommence') {
                    await this.unsubscribeFromOtherFutureOncommenceMeetings(meeting);
                } else if (await this.isSubscribedToOtherMeetingsOfSameSequence(meeting)) {
                    // Cog: unsubscribe from other meetings of the same sequence
                    await this.unsubscribeFromOtherMeetingsOfSameSequence(meeting);
                }

                // Silent unsubscribe the meeting if it's already subscribed
                if (this.isWaitingSubscriber(meeting)) {
                    await this.unsubscribeMeeting(meeting.id, false);
                }

                // Then subscribe to this meeting
                await this.subscribeMeeting(meeting.id);
            } catch (err) {
                if (err.response?.status !== 403) {
                    this.$store.dispatch('setErrors', err.response?.data);
                }
            }
        },
        isSubscribedToOtherMeetingsOfSameSequence(meeting) {
            return this.meetings.some(
                sub => sub.sequence == meeting.sequence
                && sub.id != meeting.id
                && this.$moment(sub.start).isAfter(this.$moment())
            )
        },
        unsubscribeFromOtherMeetingsOfSameSequence(meeting) {
            const sequence = meeting.sequence
            // Get all meetings of the same sequence that are not the current meeting and that are in the future
            const otherMeetings = this.meetings.filter(sub =>
                sub.sequence == sequence
                && sub.id != meeting.id
                && this.$moment(sub.start).isAfter(this.$moment())
            )
            // Unsubscribe from other meetings with forced=true to avoid penalizing the user
            // (this is an automatic unsubscription when taking a place from waitlist)
            const promises = otherMeetings.map(meeting => {
                return this.unsubscribeMeeting(meeting.id, false, true)
            })
            return Promise.all(promises)
        },
        unsubscribeFromOtherFutureOncommenceMeetings(meeting) {
            // #F_SEA_31: when promoting from L.A. on an oncommence meeting, the user can only have
            // one active oncommence subscription. Auto-unsubscribe from all other future oncommence
            // subscriptions (validated or waiting) to free the constraint.
            const otherMeetings = this.meetings.filter(sub =>
                sub.workshop?.workshop_type === 'oncommence'
                && sub.id != meeting.id
                && this.$moment(sub.start).isAfter(this.$moment())
            )
            const promises = otherMeetings.map(m => this.unsubscribeMeeting(m.id, false, true))
            return Promise.all(promises)
        },
    },
    watch: {
        // cannot put search in options, options watcher isn't deep enough
        search: {
            handler() {
                this.options.page = 1
                this.refreshPagination()
                this.$router.replace({
                    query: {
                        search: JSON.stringify(this.search),
                    }
                }).catch(e => console.log(e))
            },
            deep: true
        },
        // https://github.com/vuejs/vue/issues/2164#issuecomment-432872718
        computedOptions: {
            handler (val, oldVal) {
                if (JSON.stringify(val) != JSON.stringify(oldVal)) {
                    if (val.sortDesc != oldVal.sortDesc)
                        this.options.page = 1
                    if (val.sortBy != oldVal.sortBy)
                        this.options.page = 1
                    if (! val.sortBy)
                        this.options.sortDesc = false

                    if (val.page == this.options.page) {
                        window.scrollTo(0, 0)

                        this.refreshPagination()
                        
                        this.$router.replace({
                            query: {
                                page: this.options.page, 
                                search: JSON.stringify(this.search),
                                sortBy: this.options.sortBy,
                                sortDesc: this.options.sortDesc,
                            }
                        }).catch(e => console.log(e))
                    }
                }
            },
            deep: true
        },
    }
}
</script>
